module.exports = __webpack_public_path__ + "static/media/blue-tick.35e9922b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/blue-tick.svg
// module id = 841
// module chunks = 0